import './reset-checkbox.less';
import { memo } from 'react';

import { Checkbox } from 'antd';

const index = (props) => {
  return <Checkbox className={'so-custom-checkbox'} {...props} />;
};

export default memo(index);
